import { render, staticRenderFns } from "./ManageRole.vue?vue&type=template&id=3c4e1968&scoped=true"
import script from "./ManageRole.vue?vue&type=script&lang=js"
export * from "./ManageRole.vue?vue&type=script&lang=js"
import style0 from "./ManageRole.vue?vue&type=style&index=0&id=3c4e1968&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4e1968",
  null
  
)

export default component.exports